import React from "react"
import _map from "lodash/map"

import Typograph from "components/Typograph"

import styles from "./styles.css"

import SunIcon from "assets/svg/sun-icon.svg"
import DocumentIcon from "assets/svg/energy-document-icon.svg"
import ContractIcon from "assets/svg/contract-icon.svg"
import Banknote from "assets/svg/banknote-icon.svg"

const process = [
  {
    icon: SunIcon,
    alt: "Captação da energia",
    title: "Captação da energia​",
    description:
      "Nossos parceiros produzem energia solar em fazendas especializadas que abastecem a rede elétrica local.​"
  },
  {
    icon: DocumentIcon,
    alt: "Geração de créditos",
    title: "Geração de créditos​",
    description:
      "A luz solar é convertida em energia elétrica e injetada na rede da concessionária, gerando créditos de consumo.​"
  },
  {
    icon: ContractIcon,
    alt: "Sem burocracia​",
    title: "Sem burocracia​",
    description:
      "Empresas com contas acima de R$250 podem adquirir cotas em usinas solares sem custo inicial ou burocracia.​"
  },
  {
    icon: Banknote,
    alt: "Economia garantida​",
    title: "Economia garantida​",
    description:
      "Os créditos gerados viram desconto direto na conta. Sua empresa paga apenas o excedente e encargos da distribuidora.​"
  }
]

function ProcessCard() {
  return (
    <div className={styles.processContainer}>
      <Typograph htmlTag="h2" size="large" weight="bold" color="outer_space">
        Entenda como funciona o processo da energia compartilhada.
      </Typograph>

      <div className={styles.cardContainer}>
        {_map(process, ({ title, description, icon, alt }) => (
          <div key={title} className={styles.cardItem}>
            <img src={icon} alt={alt} />
            <Typograph
              htmlTag="h3"
              size="extra_small"
              weight="bold"
              color="outer_space"
              classNames={styles.title}
            >
              {title}
            </Typograph>
            <Typograph
              htmlTag="p"
              size="extra_small"
              weight="medium"
              color="outer_space"
            >
              {description}
            </Typograph>
          </div>
        ))}
      </div>
    </div>
  )
}
export default ProcessCard



// WEBPACK FOOTER //
// ./src/scenes/SharedEnergy/components/ProcessCard/index.js